import { render } from "./Lookup.vue?vue&type=template&id=be5ead8a"
import script from "./Lookup.vue?vue&type=script&lang=js"
export * from "./Lookup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__